import { render, staticRenderFns } from "./consignado.vue?vue&type=template&id=d1131aa8&"
import script from "./consignado.vue?vue&type=script&lang=js&"
export * from "./consignado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports